import React from 'react';
import { COPYRIGHT_INFO } from '../config.js';

const Footer = () => {
  return (
    <footer className="bg-customColor1 text-white w-full">
      <div className="container mx-auto px-4 py-6 flex flex-col space-y-6 md:space-y-0 md:flex-row md:items-center md:justify-between">
        {/* Left: Company Logo */}
        <div className="flex justify-center md:justify-start">
          <img 
            src="../image/sidekick-logo.png" 
            alt="Sidekick Logo" 
            className="h-4 sm:h-5 w-auto" 
          />
        </div>

        {/* Middle: Copyright and Powered By */}
        <div className="flex flex-col items-center space-y-4 text-center">
          <div className="text-gray-300 text-xs sm:text-sm">
            {COPYRIGHT_INFO}
          </div>
          <div className="flex flex-col sm:flex-row items-center gap-2 sm:gap-3">
            <span className="text-xs text-gray-400">Powered by:</span>
            <div className="flex flex-wrap justify-center items-center gap-4">
              <img 
                src="/image/chatgpt.png" 
                alt="ChatGPT" 
                className="h-8 sm:h-12 w-auto opacity-80"
              />
              <img 
                src="/image/llama.png" 
                alt="LLaMA" 
                className="h-4 sm:h-5 w-auto opacity-80"
              />
              <img 
                src="/image/claude.png" 
                alt="Claude" 
                className="h-10 sm:h-14 w-auto opacity-80"
              />
              <img 
                src="/image/gemini.png" 
                alt="Gemini" 
                className="h-4 sm:h-5 w-auto opacity-80"
              />
            </div>
          </div>
        </div>

        {/* Right: Social Media */}
        <div className="flex flex-col sm:flex-row items-center gap-2 sm:gap-3">
          <span className="text-xs sm:text-sm text-gray-400">Social Media:</span>
          <div className="flex gap-3">
            <a 
              href="#" 
              className="opacity-80 hover:opacity-100 transition-opacity"
              aria-label="Instagram"
            >
              <img 
                src="/image/instagram.png" 
                alt="Instagram" 
                className="h-5 sm:h-6 w-5 sm:w-6" 
              />
            </a>
            <a 
              href="#" 
              className="opacity-80 hover:opacity-100 transition-opacity"
              aria-label="Meta"
            >
              <img 
                src="/image/meta.png" 
                alt="Meta" 
                className="h-5 sm:h-6 w-5 sm:w-6" 
              />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;